
import {type FUNDING_SOURCE, type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../@type/features';
import {Feature} from '../features';
import {AbstractPayPalPayment} from './abstract/class-abstract-paypal-payment';

class PayPalVenmoPayment extends AbstractPayPalPayment {
	public gatewayId() {
		return 'peachpay_paypal_venmo';
	}

	protected fundingType(): FUNDING_SOURCE {
		return 'venmo';
	}

	protected buttonStyle() {
		return Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_VENMO_GATEWAY, 'button_style') ?? undefined;
	}
}

export {PayPalVenmoPayment};
